import React from 'react';
import { Link } from 'react-router-dom';
import { LogoMark3D } from '../logo/LogoMark3D';
import { LogoMarkFlat } from '../logo/LogoMarkFlat';
interface LogoProps {
  onClick?: () => void;
  /** Flat mark for compact contexts such as the mobile menu. */
  variant?: 'animated' | 'flat';
}
export function Logo({
  onClick,
  variant = 'animated'
}: LogoProps) {
  return <Link to="/" onClick={onClick} className="inline-flex items-center gap-3" aria-label="Qorvessa Executive Partners, home" data-id="element-155" data-mp="kb4x9lj0s4sj">
      <span className="relative block h-11 w-[82px] shrink-0" data-id="element-156" data-mp="fk51wkpjtus5">
        {variant === 'animated' ? <LogoMark3D className="h-full w-full" depth={7} step={0.8} perspective={260} data-id="element-157" data-mp="akipuelgikkx" /> : <LogoMarkFlat className="h-full w-full" data-id="element-158" data-mp="5n0eyinvpvaa" />}
      </span>
      <span className="flex flex-col leading-none" data-id="element-159" data-mp="mw7fi4y8aw7">
        <span className="font-serif text-[22px] font-semibold tracking-[0.04em] text-champagne-100" data-id="element-160" data-mp="mmgnsc2xzpg">Qorvessa</span>
        <span className="mt-1 text-[9.5px] font-medium uppercase tracking-[0.3em] text-champagne-400" data-id="element-161" data-mp="3st1fhhnv8xu5">Executive Partners</span>
      </span>
    </Link>;
}